import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import ChartTable from "@/components/ChartTable";
import { Search } from "lucide-react";

export default function AllCharts() {
  const [charts, setCharts] = useState([]);
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    const params = {};
    if (status) params.status = status;
    if (q) params.search = q;
    api.get("/charts", { params }).then((r) => setCharts(r.data)).finally(() => setLoading(false));
  };

  useEffect(load, [status]);

  return (
    <div className="p-6 md:p-10 max-w-7xl mx-auto" data-testid="all-charts-page">
      <PageHeader title="All Charts" subtitle="Full operational view across coders and QAs." />

      <div className="flex flex-col sm:flex-row gap-2 mb-4">
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="flex-1 flex gap-2">
          <div className="relative flex-1">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-search-input"
                   placeholder="Search chart ID or patient name…"
                   className="w-full border border-slate-300 rounded-lg pl-9 pr-3 py-2 text-sm focus:ring-2 focus:ring-sky-500 outline-none"/>
          </div>
          <button className="bg-slate-100 border border-slate-200 rounded-lg px-3 text-sm hover:bg-slate-200">Search</button>
        </form>
        <div className="flex gap-2">
          {[["", "All"], ["pending", "Pending"], ["in_audit", "In Audit"], ["completed", "Completed"]].map(([v, l]) => (
            <button key={v || "all"} onClick={() => setStatus(v)}
                    data-testid={`admin-filter-${v || "all"}`}
                    className={`text-sm px-3 py-1.5 rounded-lg border ${
                      status === v ? "border-sky-500 bg-sky-50 text-sky-800" : "border-slate-200 text-slate-600 hover:bg-slate-50"
                    }`}>{l}</button>
          ))}
        </div>
      </div>

      {loading ? <div className="text-slate-500 py-8 text-center">Loading…</div> :
        <ChartTable charts={charts} showCoder showQA linkTo={(c) => `/charts/${c.id}`} emptyMsg="No charts." />}
    </div>
  );
}
